"use client";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { listMissingVariables } from "../../../utils/index.js";
import { useState, useEffect } from "react";
import { Text, Button } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../Analytics/index.js";
import { StockStatus } from "../StockStatus/index.js";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { COMPONENT_NAME } from "./constants.js";
import { LocationSelectorContainerSx, IconButtonWrapper, LocationSelectorButtonSx, IconWrapper, LocationSelectorButtonCMWSx } from "./styles.js";
const LocationSelectorButton = ({
  ariaLabel,
  iconTitle,
  label,
  value,
  defaultValue,
  Icon,
  onClick,
  stockStatusData,
  isCMW = false,
  showLabel = true,
  disableButton = false,
  tooltipConfig = { showTooltip: false, Component: /* @__PURE__ */ jsx(Fragment, {}) },
  analyticsIdentifier,
  uniqueId = ""
}) => {
  const [isHydrated, setIsHydrated] = useState(false);
  useEffect(() => {
    setIsHydrated(true);
  }, []);
  const valueToUse = isHydrated || !defaultValue ? value : defaultValue;
  const missingProps = listMissingVariables({
    ariaLabel,
    label,
    onClick,
    value: valueToUse,
    ...isCMW ? { iconTitle } : {}
  });
  if ((missingProps == null ? void 0 : missingProps.length) > 0) {
    console.error(`Missing props: ${missingProps}`);
    return null;
  }
  const analyticData = {
    component: {
      identifier: analyticsIdentifier || label + " flyout",
      trackedData: analyticsIdentifier ? ["Nearby Warehouses", "Open"] : ["update"]
    }
  };
  return /* @__PURE__ */ jsx(Analytics, { analyticData, children: /* @__PURE__ */ jsxs(
    CostcoBox,
    {
      "data-testid": `${COMPONENT_NAME}${uniqueId ? `_${uniqueId}` : ""}`,
      sx: !isCMW ? LocationSelectorContainerSx : {},
      children: [
        showLabel && !isCMW && /* @__PURE__ */ jsx(
          Text,
          {
            uniqueId: `${COMPONENT_NAME}${uniqueId ? `_${uniqueId}` : ""}-label`,
            variant: "t7",
            children: label
          }
        ),
        /* @__PURE__ */ jsx(IconButtonWrapper, { children: !isCMW ? /* @__PURE__ */ jsxs(Fragment, { children: [
          tooltipConfig.showTooltip ? tooltipConfig.Component : Icon && /* @__PURE__ */ jsx(Icon, {}),
          !disableButton ? /* @__PURE__ */ jsx(
            Button,
            {
              "aria-label": ariaLabel,
              onClick,
              sx: LocationSelectorButtonSx,
              uniqueId: `${COMPONENT_NAME}${uniqueId ? `_${uniqueId}` : ""}--submit`,
              variant: "text-button",
              children: valueToUse
            }
          ) : /* @__PURE__ */ jsx(Text, { sx: LocationSelectorButtonSx, children: valueToUse })
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          Icon && /* @__PURE__ */ jsx(IconWrapper, { children: /* @__PURE__ */ jsx(Icon, { titleAccess: iconTitle }) }),
          !disableButton ? /* @__PURE__ */ jsxs(CostcoBox, { children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                "aria-label": ariaLabel,
                onClick,
                sx: LocationSelectorButtonCMWSx,
                uniqueId: `${COMPONENT_NAME}${uniqueId ? `_${uniqueId}` : ""}--submit`,
                variant: "text-button",
                children: valueToUse
              }
            ),
            (stockStatusData == null ? void 0 : stockStatusData.statusText) && (stockStatusData == null ? void 0 : stockStatusData.uniqueId) && /* @__PURE__ */ jsx(StockStatus, { ...stockStatusData })
          ] }) : /* @__PURE__ */ jsx(Text, { sx: LocationSelectorButtonSx, children: valueToUse })
        ] }) })
      ]
    }
  ) });
};
export {
  LocationSelectorButton
};
